import { gql } from '@apollo/client'

export const GET_BOOKINGS_EXPORT_METRICS = gql`
  query getBookingsExportMetrics($input: HubSpotExportFilterDtoInput!) {
    bookingsExportMetrics(input: $input) {
      totalIncome
      totalIncomeRecords
      totalQuote
      totalQuoteRecords
      totalCancelledLost
      totalCancelledLostRecords
      totalCost
      profit
      profitPercentage
    }
  }
`

export const GET_PAGED_BOOKINGS_FOR_EXPORT = gql`
  query getPagedBookingsForExport(
    $input: HubSpotExportFilterDtoInput!
    $after: String
    $before: String
    $first: Int
    $last: Int
    $where: BookingsExportDataDtoFilterInput
    $order: [BookingsExportDataDtoSortInput!]
  ) {
    bookingsExportData(
      input: $input
      after: $after
      before: $before
      first: $first
      last: $last
      where: $where
      order: $order
    ) {
      edges {
        node {
          id
          customerName
          revenue
          serviceCode
          tariffCategoryName
          currency
          contactName
          contactEmail
          exportStatus
          exportable
          booking {
            id
            status
            ourReference
            statusLabel
            isCreatedByCustomer
            createdBy
            takenBy
            hubSpotObjectId
            hubSpotSyncDate
            createdAt
            takenOn
            edgeAddresses {
              firstCollectionBy
              firstCollectionCity
              lastDeliveryCity
            }
          }
        }
      }
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasPreviousPage
        hasNextPage
      }
    }
  }
`

export const GET_PAGED_CUSTOMERS_FOR_EXPORT = gql`
  query getPagedCustomersForExport(
    $input: HubSpotExportFilterDtoInput!
    $after: String
    $before: String
    $first: Int
    $last: Int
    $where: CustomersExportDataDtoFilterInput
    $order: [CustomersExportDataDtoSortInput!]
  ) {
    customersExportData(
      input: $input
      after: $after
      before: $before
      first: $first
      last: $last
      where: $where
      order: $order
    ) {
      edges {
        node {
          id
          customer {
            id
            name
            createdAt
            createdBy
            vatIdNumber
            companyRegistrationNumber
            telephoneNumber
            postcode
            city
            hubSpotObjectId
            hubSpotSyncDate
          }
          exportStatus
        }
      }
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasPreviousPage
        hasNextPage
      }
    }
  }
`

export const GET_PAGED_CONTACTS_FOR_EXPORT = gql`
  query getPagedContactsForExport(
    $input: HubSpotExportFilterDtoInput!
    $after: String
    $before: String
    $first: Int
    $last: Int
    $where: ContactsExportDataDtoFilterInput
    $order: [ContactsExportDataDtoSortInput!]
  ) {
    contactsExportData(
      input: $input
      after: $after
      before: $before
      first: $first
      last: $last
      where: $where
      order: $order
    ) {
      edges {
        node {
          id
          exportable
          customerName
          customerCity
          customerPostcode
          contact {
            id
            name
            email
            telephoneNumber
            department
            jobRole
            createdAt
            createdBy
            hubSpotObjectId
            hubSpotSyncDate
          }
          exportStatus
        }
      }
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasPreviousPage
        hasNextPage
      }
    }
  }
`
